const ToolCard = ({ tool, isSelected }) => {
  return (
    <div className={`tool-card flex flex-col items-center justify-between bg-zinc-100 rounded-lg px-4 py-2 gap-4 transition-transform transform hover:scale-105 duration-500 ${isSelected && 'scale-110'}`}>
      <img src={tool.image} alt={tool.name} className="h-14 pt-2" />
      {/* <h3 className="text-sm font-semibold whitespace-nowrap px-2">{tool.name} <span className="text-zinc-500 text-xs">{tool.years}yrs</span></h3> */}
      <h3 className="text-md font-semibold whitespace-nowrap px-2">{tool.name}</h3>
    </div>
  );
};

export default ToolCard;